// extracted by mini-css-extract-plugin
export default {"noGamesAfterFilter":"GameList__noGamesAfterFilter--dJ9","loader":"GameList__loader--2J-"};